import { CampoDeCaixa } from '../../../components/campos'
import { TEXTOS } from '../../../lib/glossario'
import { EXPLICACAO_DO_PAPEL } from '../../../lib/papeis'
import { PAPEIS, type Papel } from '../../../types/usuario'

/**
 * As caixas de papel, com a explicação por extenso ao lado de cada uma.
 *
 * Um componente só para os dois diálogos — cadastro e alteração — porque a explicação é o conteúdo
 * que importa aqui: quem concede precisa saber que "executor" é quem aplica em produção e
 * "solicitante" é quem pede. No sistema anterior era tudo um perfil só, e quem executava homologava
 * a si mesmo. Duas cópias desta lista divergiriam no primeiro papel novo, e a que ficaria para trás
 * seria a de alteração, usada menos vezes.
 *
 * **Administrador não é oferecido a conta da contratada.** O cenário que isto fecha é um clique: na
 * UAT alguém marca ADMIN em `suporte@dbseller.com.br` "para o fornecedor ajudar a configurar", e
 * essa conta passa a alcançar atos que recaem sobre a própria empresa — reabrir um mês assinado,
 * fixar o prazo do relatório que é cobrado dela. Quem recusa de verdade é o servidor
 * (`ADMIN_NAO_E_DA_CONTRATADA`); esconder a caixa evita o clique que só produziria a recusa, e a
 * frase ao lado diz por que ela não está lá — some sem explicação seria pior que recusar.
 *
 * @param props os papéis marcados, de que lado do contrato está a conta, e o que fazer quando mudam
 * @returns o conjunto de caixas
 */
export function SelecaoDePapeis({
  papeis,
  aoAlterar,
  daContratada = false,
  desabilitado = false,
}: {
  papeis: Papel[]
  aoAlterar: (papeis: Papel[]) => void
  daContratada?: boolean
  desabilitado?: boolean
}) {
  function alternar(papel: Papel, marcado: boolean) {
    aoAlterar(marcado ? [...papeis, papel] : papeis.filter((p) => p !== papel))
  }

  const oferecidos = daContratada ? PAPEIS.filter((papel) => papel !== 'ADMIN') : PAPEIS

  return (
    <fieldset disabled={desabilitado}>
      <legend className="text-sm font-medium text-slate-800">Papéis</legend>
      <p className="mt-0.5 max-w-prose text-xs text-slate-500">{TEXTOS.usuarios.papeis}</p>
      {daContratada && (
        <p className="mt-1 max-w-prose text-xs text-slate-500">{TEXTOS.usuarios.semAdminNaContratada}</p>
      )}
      <div className="mt-2 space-y-2">
        {oferecidos.map((papel) => (
          <CampoDeCaixa
            key={papel}
            rotulo={EXPLICACAO_DO_PAPEL[papel].rotulo}
            ajuda={EXPLICACAO_DO_PAPEL[papel].ajuda}
            checked={papeis.includes(papel)}
            onChange={(e) => alternar(papel, e.target.checked)}
          />
        ))}
      </div>
    </fieldset>
  )
}
